export default "__VITE_ASSET__983bd571__"